import AceText from '@/assets/icons/ace-text.svg?react';
import SpadeSuit from '@/assets/icons/spade-suit.svg?react';
import { cn } from '@/shared/utils/cn';

export interface AceBadgeProps {
  className?: string;
}

export function AceBadge({ className }: AceBadgeProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-1 rounded-full rounded-sm bg-white p-1 pr-2',
        className,
      )}
    >
      <SpadeSuit className="size-4.5 text-black" />
      <AceText className="w-11" />
    </div>
  );
}
